const currentUrl = window.location.href;
const url = new URL(currentUrl);
const baseUrl = url.protocol + "//" + url.host + "/";

export const apiUrl = process.env.REACT_APP_API_URL;
const apiAuth = apiUrl + 'authentication/';
const apiAdmin = apiUrl + 'admin/';
const apiUser = apiUrl + 'user/';

export const ForgotPassword = apiAuth + "ForgotPassword";
export const ResetPassword = apiAuth + "ResetPassword";
export const ChangePassword = apiAuth + "ChangePassword";
export const Login = apiAuth + "Login";
export const User = apiAuth + "User";
export const UsersList = apiAdmin + "UsersList";
export const RoleList = apiAdmin + "RoleList";
export const AddRole = apiAdmin + "NewRole";
export const EditRole = apiAdmin + "EditRole";
export const RemoveRole = apiAdmin + "RemoveRole";

export const PermissionList = apiAdmin + "PermissionList";

export const NewUser = apiAdmin + "NewUser";
export const EditUser = apiAdmin + "EditUser";

export const DashboardAfluencia = apiUser + "DashboardAfluencia";
export const DashboardIndicadoresPrincipales = apiUser + "DashboardIndicadoresPrincipales";
export const DashboardAnalisisVentas = apiUser + "DashboardAnalisisVentas";
export const ComparativoDeVentas = apiUser + "ComparativoDeVentas";
export const EvolucionVentasTotales = apiUser + "EvolucionVentasTotales";
export const EvolucionVentasCumplimiento = apiUser + "EvolucionVentasCumplimiento";
export const EvolucionVentasDesgloseMes = apiUser + "EvolucionVentasDesgloseMes";
export const EvolucionVentasTiendaTotales = apiUser + "EvolucionVentasTiendaTotales";
export const EvolucionVentasTiendaCumplimiento = apiUser + "EvolucionVentasTiendaCumplimiento";
export const EvolucionVentasTiendaDesgloseMes = apiUser + "EvolucionVentasTiendaDesgloseMes";
export const DiarioComparativoVentas = apiUser + "DiarioComparativoVentas";
export const RankingVentasPorMall = apiUser + "RankingVentasPorMall";
export const VentasPorCategoria = apiUser + "VentasPorCategoria";

export const VentasGeneral = apiUser + "VentasGeneral";
export const VentasGeneralPresupuesto_RubroList = apiUser + "VentasGeneralPresupuesto_RubroList";
export const VentasGeneralPresupuesto = apiUser + "VentasGeneralPresupuesto";
export const VentasDiarias = apiUser + "VentasDiarias";
export const RankingVentasMensual = apiUser + "RankingVentasMensual";
export const RankingVentasAnual = apiUser + "RankingVentasAnual";
export const RankingVentasAnualM2 = apiUser + "RankingVentasAnualM2";
export const CrecimientoMensual = apiUser + "CrecimientoMensual";
export const VentasM2Locatario = apiUser + "VentasM2Locatario";
export const ProvisionVentas = apiUser + "ProvisionVentas";
export const FlashSemanal = apiUser + "FlashSemanal";

export const IndicadoresVentasMes = apiUser + "IndicadorVentasMes";
export const IndicadoresVentasMesRubros = apiUser + "IndicadorVentasMesRubros";
export const IndicadoresListaContratosMes = apiUser + "IndicadoresListaContratosMes";
export const IndicadoresComparativaVentaAnual = apiUser + "IndicadoresComparativaVentaAnual";

export const IndicadoresVentasMesM2 = apiUser + "IndicadorVentasMesM2";
export const IndicadoresVentasMesM2Rubros = apiUser + "IndicadorVentasMesM2Rubros";
export const IndicadoresListaContratosMesM2 = apiUser + "IndicadoresListaContratosMesM2";
export const IndicadoresComparativaVentaAnualM2 = apiUser + "IndicadoresComparativaVentaAnualM2";
export const IndicadoresComparativaMesCerrado = apiUser + "IndicadoresComparativaMesCerrado";

export const IndicadoresVentasMesCerrado = apiUser + "IndicadorVentasMesCerrado";
export const IndicadoresVentasMesCerradoRubros = apiUser + "IndicadorVentasMesCerradoRubros";
export const IndicadoresListaContratosMesCerrado = apiUser + "IndicadoresListaContratosMesCerrado";


export const IndicadoresVentaGeneralMes = apiUser + "IndicadoresVentaGeneralMes";
export const IndicadoresVentaGeneralMesM2 = apiUser + "IndicadoresVentaGeneralMesM2";

export const GraficaVentasTotalesMes = apiUser + "GraficaVentasTotalesMes";
export const GraficaVentasTotalesMesM2 = apiUser + "GraficaVentasTotalesMesM2";

export const ListaContratos = apiUser + "ListaContratos";
export const ActualizarFechaContratos = apiUser + "ActualizarFechaContratos";

export const MapaCalorVacancyList = apiUser + "MapaCalorVacancyList";
export const MapaCalorVacancyChangeStatus = apiUser + "MapaCalorVacancyChangeStatus";
export const MapaCalorVacancyGetVacancy = apiUser + "MapaCalorVacancyGetVacancy";
export const MapaCalorAllin = apiUser + "MapaCalorAllin";
export const MapaCalorAllIn_CategoryList = apiUser + "MapaCalorAllIn_CategoryList";
export const MapaCalorAllIn_RemoveCategory = apiUser + "MapaCalorAllIn_RemoveCategory";
export const MapaCalorAllIn_AddCategory = apiUser + "MapaCalorAllIn_AddCategory";
export const MapaCalorAllIn_EditCategory = apiUser + "MapaCalorAllIn_EditCategory";

export const MapaCalorVistaGeneral_IndicadorVentas = apiUser + "MapaCalorVistaGeneral_IndicadorVentas";
export const MapaCalorVistaGeneral_ReporteCierre = apiUser + "MapaCalorVistaGeneral_ReporteCierre";
export const MapaCalorMantenimiento = apiUser + "MapaCalorMantenimiento";
export const MapaMantenimiento_ListaContratos = apiUser + "MapaMantenimiento_ListaContratos";
export const MapaCalorMantenimiento_guardarContrato = apiUser + "MapaCalorMantenimientoChangeStatus";


export const AfluenciaDiariaPeatonal = apiUser + "AfluenciaDiariaPeatonal";
export const AfluenciaMensualPeatonal = apiUser + "AfluenciaMensualPeatonal";
export const AfluenciaDiariaParking = apiUser + "AfluenciaDiariaParking";
export const AfluenciaMensualParking = apiUser + "AfluenciaMensualParking";

export const ListaRoja = apiUser + "ListaRoja";
export const GetInflacion_Anio = apiUser + "GetInflacion_Anio";
export const SetInflacion_Anio = apiUser + "SetInflacion_Anio";
export const GetBloquearCierre = apiUser + "GetBloquearCierre";
export const SetBloquearCierre = apiUser + "SetBloquearCierre";

export const ListaLocatarios = apiUser + "ListaLocatarios";
export const ClasificacionComercial = apiUser + "ClasificacionComercial";
export const ClasificacionSubComercial = apiUser + "ClasificacionSubComercial";
export const GetDataLocatario = apiUser + "GetDataLocatario";
export const ActualizarLocatario = apiUser + "ActualizarLocatario";
export const CierreVentasPorLocatario = apiUser + "CierreVentasPorLocatario";
export const ActualizarCierreVentas = apiUser + "ActualizarCierreVentas";

export const EstadosCuentaLista = apiUser + "EstadosCuentaLista";
export const DetalleEstadoCuenta = apiUser + "DetalleEstadoCuenta";
export const GetCuentasRecaudadoras = apiUser + "GetCuentasRecaudadoras";
export const GetlistaCobranzaIndicadores = apiUser + "GetlistaCobranzaIndicadores";
export const GetlistaDeudasVencidas = apiUser + "GetlistaDeudasVencidas";
export const GetDetalleDeuda = apiUser + "GetDetalleDeuda";

export const TipoMotivoList = apiUser + "TipoMotivoList";
export const MotivosList = apiUser + "MotivosList";
export const ListaLocales = apiUser + "ListaLocales";
export const RegistrarAmonestacion = apiUser + "RegistrarAmonestacion";
export const VistaAmonestacion = apiUser + "VistaAmonestacion";
export const RegistrarAprobacionDesaprobacionAmonestacion = apiUser + "RegistrarAprobacionDesaprobacionAmonestacion";
export const GetDni = apiUser + "GetDni";
export const BitacoraDiariaVentas = apiUser + "BitacoraDiariaVentas";
export const BitacoraEvento_Agregar = apiUser + "BitacoraEvento_Agregar";
export const ContratoList = apiUrl + "Authentication/ContratosPorEmail";
export const GetContratoList = (email) => `${apiUrl}Authentication/ContratosPorEmail/${email}`;

export const DashboardIndicadoresVentas = apiUser + "DashboardIndicadoresVentas";
export const DashboardVentasTotalesxMes = apiUser + "DashboardVentasTotalesxMes";
export const DashboardPromedioRubroXMesVsTotales = apiUser + "DashboardPromedioRubroXMesVsTotales";
export const CierreVentas_Locatario = apiUser + "CierreVentas_Locatario";
export const ActualizarCierreVentas_Locatario = apiUser + "ActualizarCierreVentas_Locatario";
export const GetRegistrarCierreVentas_Locatario = apiUser + "GetRegistrarCierreVentas_Locatario";
export const SetRegistrarCierreVentas_Locatario = apiUser + "SetRegistrarCierreVentas_Locatario";
export const GetUsuarios_Locatario = apiUser + "GetUsuarios_Locatario";
export const SetUsuarios_Locatario = apiUser + "SetUsuarios_Locatario";
export const DetalleEstadoCuenta_Locatario = apiUser + "DetalleEstadoCuenta_Locatario";
export const ListaRubro = apiUser + "ListaRubro";
export const ListaCebe = apiUser + "ListaCebe";
export const GetNotifications = apiUser + "GetNotifications";
export const RouteResetPassword = baseUrl + "auth/ResetPassword";
export const RouteActivateAccount = baseUrl + "auth/ActivateAccount";


//export const GetGarantiasByRuc = (nroContrato) => `${apiUrl}garantias/all/find_by_contrato/${nroContrato}`;
export const GetGarantiasByRuc = (ruc) => `${apiUrl}garantias/all/find_by_ruc/${ruc}`;
export const GetGarantiasByRucContrato = (ruc, nroContrato) => `${apiUrl}garantias/all/find_by/ruc/${ruc}/contrato/${nroContrato}`;
export const GetMallList = `${apiUrl}garantias/masterdata/malls`;
export const GetBancoListByLevel = (nivel) => `${apiUrl}garantias/masterdata/bancos/find_by_nivel/${nivel}`;
export const GetBancoListHabilitadoxCartaFianza = `${apiUrl}garantias/masterdata/bancos/find_habilitados_carta_fianza`;
export const GetBancoListHabilitadoxOperacionEfectivo = `${apiUrl}garantias/masterdata/bancos/find_habilitados_operacion_efectivo`;
export const SaveBanco = `${apiUrl}garantias/masterdata/bancos`;
export const GetMonedaList = `${apiUrl}garantias/masterdata/monedas`;
export const GetGarantiaById = (id) => `${apiUrl}garantias/all/${id}`;
export const GetDetalleGarantiaLocatario = (id) => `${apiUrl}garantias/detalle_garantia_locatario/${id}`;

export const GetGarantiaFullById = (id) => `${apiUrl}garantias/all/full/${id}`;
export const GetRecepcionesByGarantiaId = (id) => `${apiUrl}garantias/${id}/recepciones`;
export const AddCartaFianza = () => `${apiUrl}garantias/cartas_fianza`;
export const GetRuc = apiUser + "GetRuc";

export const ValidationGarantiaLocatario = `${apiUrl}garantias/locatario/validation`;
export const SaveDetalleGarantia = `${apiUrl}garantias/detalle_garantia`;
export const UpdateEstadoDetalleGarantia = `${apiUrl}garantias/detalle_garantia/update_estado`;
export const UploadAdjuntoDetalleGarantia = (id) => `${apiUrl}garantias/detalle_garantia/upload?idDetalleGarantia=${id}`;
export const UploadAdjuntoDetalleGarantiaExcepcion = (id, updatedBy) => `${apiUrl}garantias/excepciones/locatario/upload?idGarantiaExcepcion=${id}&updatedBy=${updatedBy}`;
export const GetDetalleGarantiasListToRevision = `${apiUrl}garantias/detalle_garantia/revisiones`;
export const GetDetalleGarantiasListFullWithFilter = `${apiUrl}garantias/detalle_garantia/full_with_filter`;
//@JD
export const GetDetalleGarantiasListToRevision2 = `${apiUrl}garantias/detalle_garantia/revisiones`;
export const GetDetalleGarantiasListFullWithFilter2 = `${apiUrl}garantias/detalle_garantia/full_with_filter2`;


export const SaveRevisionGarantiaDetalle = `${apiUrl}garantias/detalle_garantia/revisiones`;

export const GetCartasFianzaByVencer = `${apiUrl}garantias/requerimiento_cf/cartas_fianza_x_vencer`;
export const GetCartasNotarales = `${apiUrl}garantias/requerimiento_cf/cartas_notariales`;

export const GetConfigurationGenerationCartaNotarial = `${apiUrl}garantias/requerimiento_cf/configuracion`;
export const SaveConfigurationGenerationCartaNotarial = `${apiUrl}garantias/requerimiento_cf/configuracion`;
export const GenerationCartasNotariales = `${apiUrl}garantias/requerimiento_cf/cartas_notariales/generacion`;

///Pendiente a depurar
export const UploadAdjuntoRequerimiento = `${apiUrl}garantias/requerimiento_carta_fianza/enviar_carta_requerimiento`;
export const GenerarCartaRequerimiento = `${apiUrl}garantias/requerimiento_carta_fianza/generar_carta_requerimiento`;

export const CreateRequerimientoCartaFianza = `${apiUrl}garantias/requerimiento_carta_fianza`;
export const GetDataToCarta = `${apiUrl}garantias/requerimiento_carta_fianza/data_to_carta`;
///Pendiente a depurar - END

export const GeneracionCartaDesistimiento = `${apiUrl}garantias/renovacion_cf/cartas_notariales/generacion`;
export const GeneracionCartaEjecucion = `${apiUrl}garantias/ejecucion_cf/cartas_notariales/generacion`;

export const GetCierreMes = `${apiUser}GetCierreMes`
export const SaveCierreMes = `${apiUser}SaveCierreMes`
export const GetAnioComparativo = `${apiUser}GetAnioComparativo`
export const SaveAnioComparativo = `${apiUser}SaveAnioComparativo`
export const GetMantenimientoTiendas = `${apiUser}GetMantenimientoTiendas`
export const SaveMantenimientoTiendas = `${apiUser}SaveMantenimientoTiendas`
export const EditMantenimientoTiendas = `${apiUser}EditMantenimientoTiendas`
export const DeleteContratoSimil = (idContratoSimil) => `${apiUser}DeleteContratoSimil?idContratoSimil=${idContratoSimil}`;

export const DeleteRequerimiento = `${apiUrl}garantias/requerimiento_carta_fianza`

export const CreateRenovacionCartaFianza = `${apiUrl}garantias/renovacion_cf`;

export const GetGarantiasToRecepcion = `${apiUrl}garantias/detalle_garantia/full_with_filter`;
export const GetEstadosRecepcionByTipoGarantia = (codigoTipoGarantia) => `${apiUrl}garantias/masterdata/estados_recepcion/${codigoTipoGarantia}`;
export const SaveGarantiaRecepcion = () => `${apiUrl}garantias/recepciones`;
export const GetAllGarantiaRecepcion = `${apiUrl}garantias/recepciones`;

export const GeneracionProrroga = `${apiUrl}garantias/ejecucion_cf/prorrogas`;

export const GetGarantiasBovedaStateList = `${apiUrl}garantias/masterdata/cartas_fianza/ubicaciones/estados`;
export const GetGarantiasBovedaAuthorizationList = `${apiUrl}garantias/masterdata/cartas_fianza/ubicaciones/autorizaciones`;
export const SaveGarantiaBoveda = `${apiUrl}garantias/recepciones/ubicaciones`;

export const GetAllTiposExcepcion = `${apiUrl}garantias/masterData/tipos_excepcion`;
export const GetTiposGarantiaList = `${apiUrl}garantias/masterData/tipos_garantia`;
export const GetGarantiaDetalleFullById = (id) => `${apiUrl}garantias/detalle_garantia/full/${id}`;
export const SaveFarantiaExcepcion = `${apiUrl}garantias/excepciones`;
export const UploadSustentoExcepcionGarantia = (id, updatedBy) => `${apiUrl}garantias/excepciones/upload_sustento?idGarantiaExcepcion=${id}&updatedBy=${updatedBy}`;
export const DeleteExcepcion = `${apiUrl}garantias/excepciones`;

export const ReportGarantiaPorVencimiento = `${apiUrl}garantias/informes/vencimiento`;
export const ReportGradoDeAvance = `${apiUrl}garantias/informes/grado_avance`;

export const GetEstadosEntregaCarta = `${apiUrl}garantias/masterdata/estados_entrega_cf`;
export const SaveEntregaCartaRequerimiento = `${apiUrl}garantias/requerimiento_cf/entrega`;
export const SaveEntregaCartaDesistimiento = `${apiUrl}garantias/desistimiento_cf/entrega`;
export const SaveEntregaCartaEjecucion = `${apiUrl}garantias/ejecucion_cf/entrega`;
export const SaveChequeEjecucion = `${apiUrl}garantias/ejecucion_cf/ingreso_cheque`;

export const ValidacionBancoEmail = `${apiUrl}garantias/banco/verificacion_cf/send_email`;

export const GetMomentoEntrega = `${apiUrl}garantias/masterdata/momentos_entrega_cf`;
export const GetGarantiasByEstadoCuenta = (ruc) => `${apiUrl}garantias/all/find_by_estado_cuenta/${ruc}`;
export const SaveMomentoEntrega = `${apiUrl}garantias/recepciones/entrega`;
export const UploadSustentoMomentoEntrega = (id, updatedBy) => `${apiUrl}garantias/recepciones/upload_sustento_entrega?idGarantiaDetalle=${id}&updatedBy=${updatedBy}`;


export const UpdateGarantiaGeneralValue = `${apiUrl}garantias/masterdata/general_value`;
export const GetGeneralValues = `${apiUrl}garantias/masterdata/general_value`;
export const GetDataInfoLocatario = (idLocatario) => `${apiUrl}garantias/masterdata/data_locatario/${idLocatario}`;

export const GetClienteGarantiaResumen = `${apiUrl}garantias/informes/clientes_garantia/resumen`;
export const GetClienteGarantiaData = `${apiUrl}garantias/informes/clientes_garantia/data`;

export const UploadAllIn = (year) => `${apiUrl}User/CargaAllin?anio=${year}`;

export const SaveExceptionReviewCobranza = `${apiUrl}garantias/excepciones/review/cobranza`;
export const SaveExceptionReviewTesoreria = `${apiUrl}garantias/excepciones/review/tesoreria`;